import axios from 'axios'

const ORGS = '/api/orgs'
const INVITES = '/api/invites'

const authCfg = (token) => ({ headers: { Authorization: `Bearer ${token}` } })

// --- Organisations ---------------------------------------------------------

const listMyOrgs = async (token) => {
  const res = await axios.get(ORGS, authCfg(token))
  return res.data
}

const createOrg = async (data, token) => {
  const res = await axios.post(ORGS, data, authCfg(token))
  return res.data
}

const getOrg = async (slug, token) => {
  const res = await axios.get(`${ORGS}/${slug}`, authCfg(token))
  return res.data
}

const updateOrg = async ({ slug, ...body }, token) => {
  const res = await axios.patch(`${ORGS}/${slug}`, body, authCfg(token))
  return res.data
}

const deleteOrg = async ({ slug, confirmBowtieDeletion }, token) => {
  const res = await axios.delete(`${ORGS}/${slug}`, {
    ...authCfg(token),
    data: confirmBowtieDeletion ? { confirmBowtieDeletion: true } : {},
  })
  return res.data
}

const leaveOrg = async (slug, token) => {
  const res = await axios.post(`${ORGS}/${slug}/leave`, {}, authCfg(token))
  return res.data
}

// --- Members --------------------------------------------------------------

const changeMemberRole = async ({ slug, userId, role }, token) => {
  const res = await axios.patch(`${ORGS}/${slug}/members/${userId}`, { role }, authCfg(token))
  return res.data
}

const removeMember = async ({ slug, userId }, token) => {
  const res = await axios.delete(`${ORGS}/${slug}/members/${userId}`, authCfg(token))
  return res.data
}

// --- Invites -------------------------------------------------------------

const listInvites = async (slug, token) => {
  const res = await axios.get(`${ORGS}/${slug}/invites`, authCfg(token))
  return res.data
}

const createInvite = async ({ slug, email, role }, token) => {
  const res = await axios.post(`${ORGS}/${slug}/invites`, { email, role }, authCfg(token))
  return res.data
}

const resendInvite = async ({ slug, id }, token) => {
  const res = await axios.post(`${ORGS}/${slug}/invites/${id}/resend`, {}, authCfg(token))
  return res.data
}

const revokeInvite = async ({ slug, id }, token) => {
  const res = await axios.delete(`${ORGS}/${slug}/invites/${id}`, authCfg(token))
  return res.data
}

const previewInvite = async (inviteToken) => {
  const res = await axios.get(`${INVITES}/${inviteToken}`)
  return res.data
}

const acceptInvite = async (inviteToken, token) => {
  const res = await axios.post(`${INVITES}/accept`, { token: inviteToken }, authCfg(token))
  return res.data
}

const orgService = {
  listMyOrgs,
  createOrg,
  getOrg,
  updateOrg,
  deleteOrg,
  leaveOrg,
  changeMemberRole,
  removeMember,
  listInvites,
  createInvite,
  resendInvite,
  revokeInvite,
  previewInvite,
  acceptInvite,
}

export default orgService
